import type { IHistoryItem } from '@/framework';
import { getFramework } from '@/framework/instance';
import type { ILayerProps } from '@/version-types';
import { WATERMARK_HISTORY_KEY } from './constants';

type IHistoryData = {
    newLayer: ILayerProps;
    oldLayer: ILayerProps;
    updateBridge: (layer: ILayerProps) => Promise<void>;
};

export class WatermarkLayerHistory {
    constructor(private id: string) {
        const framework = getFramework(this.id);
        // 注册历史记录
        framework.history.register(WATERMARK_HISTORY_KEY, {
            onRedoUndo: async (historyItem: IHistoryItem<IHistoryData>, isRedo: boolean, isUndo: boolean) => {
                const framework = getFramework(this.id);
                const { newLayer, oldLayer, updateBridge } = historyItem.data.data;

                framework.operate.globalMask.show({
                    loading: true,
                    background: true,
                });

                if (isRedo) {
                    framework.stage.addOrUpdate(newLayer);
                    await updateBridge(newLayer);
                }
                if (isUndo) {
                    if (oldLayer) {
                        framework.stage.addOrUpdate(oldLayer);
                        await updateBridge(oldLayer);
                    } else {
                        framework.operate.delLayer(newLayer.id);
                        await updateBridge(newLayer);
                    }
                }

                framework.operate.globalMask.hide();
            },
            onMessage: () => {
                // [todo] 图片编辑器，水印图层不支持多人协同，不需要处理
            },
        });
    }
}
